// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"dfeb084a","341":"6e0eebb5","345":"6a5c51b2","356":"49480ff8","385":"26bdefc8","507":"d923b18b","680":"1c0c752a","872":"914aa209","904":"388db9b5","916":"88ea7fd0"}[chunkId] + ".chunk.js";
};